module.exports = __webpack_public_path__ + "media/images/top/fv_right-d4ba9316c59c27b402917362edf7cab4.webp";